import React, { ReactNode } from "react";
import classnames from "classnames";

import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";
import { useIntlTranslate } from "../../../../hooks";

import "./SortButton.scss";

interface SortButtonProps {
  isSorted: boolean;
  isSortedDesc: boolean;
  children: ReactNode;
}

const sortDirectionMap = {
  sort_default: "sort_asc",
  sort_asc: "sort_desc",
  sort_desc: "sort_default",
};

export const SortButton = ({
  children,
  isSorted,
  isSortedDesc,
}: SortButtonProps) => {
  const translate = useIntlTranslate();
  const sortingClasses = classnames("sort-button", {
    "sort-button--asc": isSorted && !isSortedDesc,
    "sort-button--desc": isSorted && isSortedDesc,
  });
  const currentSortDirection = isSorted
    ? isSortedDesc
      ? "sort_desc"
      : "sort_asc"
    : "sort_default";

  const nextSortDirection = sortDirectionMap[currentSortDirection];
  const ariaLabel = translate("aria_table_sort_by", {
    sortDirection: translate(nextSortDirection),
  });

  return (
    <UnstyledButton className={sortingClasses} aria-roledescription={ariaLabel}>
      {children}
    </UnstyledButton>
  );
};
